import {
  DonationFormCategory,
  MembershipValidityPeriod,
  ProductDonationRecurrenceInterval,
  TicketingFormCategory,
} from "@simplyk/common";

import type { FormType } from "./LiveFormEditorContext";

import { DonationFormWithUserOrOrgAccessOutput, TicketingOutput } from "@/common/types/trpc";

type GetShowRenewalEmailsArgs = {
  formType: FormType;
  formCategory: TicketingFormCategory | DonationFormCategory;
  apiFormObject: TicketingOutput | DonationFormWithUserOrOrgAccessOutput;
};

export const getShowRenewalEmails = ({ formType, formCategory, apiFormObject }: GetShowRenewalEmailsArgs): boolean => {
  if (formType === "ticketing" && formCategory === TicketingFormCategory.MembershipV2) {
    const rates = (apiFormObject as TicketingOutput).rates ?? [];
    return rates.some(
      (rate) =>
        rate.membershipValidityPeriod === MembershipValidityPeriod.OneYearAfterPayment ||
        rate.membershipValidityPeriod === MembershipValidityPeriod.AtDate
    );
  }

  if (formType === "donation-form") {
    const fields = (apiFormObject as DonationFormWithUserOrOrgAccessOutput).donationFormFields ?? [];
    return fields.some((field) =>
      field.donationFormAmounts?.some(
        (amount) => amount.recurrenceInterval === ProductDonationRecurrenceInterval.Yearly
      )
    );
  }

  return false;
};
